import { PipeTransform, Pipe } from "@angular/core";
@Pipe({
  name: "textEllipsis",
})
export class EllipsisPipe implements PipeTransform {
  transform(text: string | null, length?: number): string {
    let spanToBind = "";
    if (text !== undefined) {
      if (text.length > length) {
        text = text.trim();
        spanToBind = `${text.substr(0, length)}...`;
      } else {
        text = text.trim();
        spanToBind = `${text} `;
      }
    }
    return spanToBind;
  }
}
